export const getUserPermissions = (user) => {
  if (!user) return [];
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];
  const unique = new Set(permissions.filter(Boolean));
  return Array.from(unique);
};

export const isAdminUser = (user) => {
  if (!user) return false;
  const permissions = getUserPermissions(user);
  return permissions.includes("branch.access.any");
};

export const hasPermission = (user, permissionKey) => {
  if (!user || !permissionKey) return false;
  const permissions = getUserPermissions(user);
  return permissions.includes(permissionKey);
};

export const hasAnyPermission = (user, permissionKeys) => {
  if (!Array.isArray(permissionKeys) || !permissionKeys.length) return false;
  return permissionKeys.some((key) => hasPermission(user, key));
};
